import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { resetPasswordApi } from "../APIs/API";
import Cookies from "js-cookie";
import { MyContext } from "../MyContext/MyProvider";

const Resetpassword = () => {
  const location = useLocation();
  const otp = location.state.code;
  const { setIsLoading } = useContext(MyContext);

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setconfirmPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const toggleCPasswordVisibility = () => {
    setconfirmPassword(!confirmPassword);
  };

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const validatePasswordMatch = (value) => {
    return value === watch("new_password") || "Passwords do not match";
  };

  const onSubmit = async (data) => {
    setIsLoading(true);

    data = { ...data, code: otp };
    try {
      const res = await resetPasswordApi(data);
      Cookies.remove("role");
      res && navigate("/login");
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <div className="login-main-container h-center v-center">
        <div className="login-container w-100 ">
          <div className="input-form-main ">
            <h3 className="text-medium-black ">Reset Password</h3>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="input-form h-center flex-column forgetpswd"
            >
              <div className="mt-50 d-flex flex-column gap-12 pt-3">
                <label className="large fw-normal text-medium-black">
                  Enter Your Password
                </label>
                <div className="input-password">
                  <input
                    {...register("new_password", {
                      required: "Password is required",
                      minLength: {
                        value: 10,
                        message: "Must be at least 10 characters long",
                      },
                      pattern: {
                        value: /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{8,}$/,
                        message:
                          "Must contain at least one uppercase letter, one special character, and one digit",
                      },
                    })}
                    inputMode="text"
                    type={showPassword ? "text" : "password"}
                    className="form-input pswd-feild"
                    placeholder="*****"
                  />

                  <Icon
                    icon={showPassword ? "fa-solid:eye" : "fa6-solid:eye-slash"}
                    className="eye-icon"
                    onClick={togglePasswordVisibility}
                    color="#000000"
                  />
                </div>
                {errors.new_password && (
                  <span className="error">{errors.new_password.message}</span>
                )}
              </div>
              <div className="mt-24 d-flex flex-column gap-12 ">
                <label className="large fw-normal text-medium-black">
                  Confirm Your Password
                </label>
                <div className="input-password">
                  <input
                    {...register("confirm_password", {
                      required: "Please confirm your password",
                      validate: validatePasswordMatch,
                    })}
                    inputMode="text"
                    type={confirmPassword ? "text" : "password"}
                    className="form-input pswd-feild"
                    placeholder="*****"
                  />

                  <Icon
                    icon={
                      confirmPassword ? "fa-solid:eye" : "fa6-solid:eye-slash"
                    }
                    className="eye-icon"
                    onClick={toggleCPasswordVisibility}
                    color="#000000"
                  />
                </div>
                {errors.confirm_password && (
                  <span className="error">
                    {errors.confirm_password.message}
                  </span>
                )}
              </div>

              <div className="bottom-btn-div mt-5 pt-1">
                <button className="btn-primary" type="submit">
                  Confirm
                </button>
                <div className="mt-3">
                  <label className="small fw-normal h-center v-center gap-1 text-black">
                    Already have an account?
                    <Link to="/">
                      <label className=" text-red link">Login</label>
                    </Link>
                  </label>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Resetpassword;
